/** Status paczki zmian po stronie backendu (`BookingChangeStatus`). */
export enum BookingChangeStatus {
  DRAFT = 'DRAFT',
  PENDING_CLIENT = 'PENDING_CLIENT',
  APPLIED = 'APPLIED',
  REJECTED = 'REJECTED',
  CANCELLED = 'CANCELLED',
}
